import { ProductTypesEnum } from '@bondsports/types';

export const MIN_QUANTITY = 1;

export const QUANTITY_DECIMALS = 2;

/**
 * Product types that are granted per person, so their cart quantity can never exceed one.
 */
export const NON_QUANTIFIABLE_PRODUCT_TYPES: ProductTypesEnum[] = [
	ProductTypesEnum.MEMBERSHIP,
	ProductTypesEnum.PACKAGE,
];
